export default __webpack_public_path__ + "static/media/ser5.163b8769.jpg";